import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap, tap } from 'rxjs';
import { UserCreateRequestBody, UserResponseDTO, UserUpdateRequestBody } from '../../../../shared/models/user.model';
import { AppSessionService } from '../../../../shared/session/app-session.service';
import { AppAuthService } from '../../../../shared/services/app-auth.service';
import { environment } from '../../../../environments/environment';
import { ChangeCurrentUserPasswordReqBody, ChangePasswordRequestBody } from '../../../../shared/models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private readonly _httpClient = inject(HttpClient);
  private readonly _appSessionService = inject(AppSessionService);
  private readonly _authService = inject(AppAuthService);

  getUserById(id: number): Observable<UserResponseDTO> {

    return this._httpClient.get<UserResponseDTO>(`${environment.urlBackend}/api/users/${id}`).pipe(tap(() => { }));

  }

  createUser(userData: UserCreateRequestBody): Observable<UserResponseDTO> {

    return this._httpClient.post<UserResponseDTO>(`${environment.urlBackend}/api/users`, userData).pipe();
  }

  updateUser(id: string, userData: UserUpdateRequestBody): Observable<UserResponseDTO> {
    return this._httpClient.put<UserResponseDTO>(`${environment.urlBackend}/api/users/${id}`, userData).pipe(tap(() => { }));
  }

  deleteUser(id: string): Observable<void> {
    return this._httpClient.delete<void>(`${environment.urlBackend}/api/users/${id}`).pipe(tap(() => { }));
  }

  changeCurrentUserPassword(body: ChangeCurrentUserPasswordReqBody): Observable<UserResponseDTO> {
    return this._httpClient.post<UserResponseDTO>(`${environment.urlBackend}/api/profile/change-password`, body).pipe();
  }

  resetUserPassword(body: ChangePasswordRequestBody, id: string) {
    return this._httpClient.put<UserResponseDTO>(`${environment.urlBackend}/api/users/${id}/reset-password`, body).pipe();
  }
}
